/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-comment/bulbcomment
 */

import { Plugin } from 'ckeditor5';
import BulbCommentUI from './bulbcommentui';

/**
 * Plugin to add comment on media and non-media elements.
 *
 * @extends Plugin
 */
export default class BulbComment extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbCommentUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbComment' as const;
  }
}
